<template>
  <el-card class="k-stat-card">
    <i class="k-stat-card__icon" :class="icon"></i>

    <p class="k-stat-card__value">{{value}}</p>
    <p class="k-stat-card__title">{{title}}</p>
  </el-card>
</template>

<script>
/**
 * Component: k-stat-card - Карточка со статистикой
*
* @version 1.0.0
*/


export default {
  name: 'k-stat-card',

  props: {
    title: {
      type: String,
      required: true,
    },

    icon: {
      type: String,
      required: true,
    },

    value: {
      type: [Number, String],
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-stat-card {
  $this: &;

  width: 200px;
  text-align: center;
  margin: $vp 0;
  padding-top: $vp;

  &__icon {
    font-size: 32px;
    color: #409EFF;
  }
}
</style>
